module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bh-3310879d5f14a62669bfedce94492cba.svg";